import {useEffect, useState} from 'react';

import Amplify from 'aws-amplify';
import {Auth} from '@aws-amplify/auth';

import {fetch} from 'services/UsersService';


export const useAuth = ({account}) => {
    if (typeof account === 'undefined' || account === null) {
        console.debug(
            'LOGIN APP. AUTH CONTEXT. ACCOUNT IS UNDEFINED OR NULL',
            account
        );
        // throw new Error('Account is required parameter');
        return {user: undefined, profile: undefined, session: undefined};
    }

    const [user, setUser] = useState(null);
    const [profile, setProfile] = useState(null);
    const [session, setSession] = useState(null);

    useEffect(() => {
        const run = async () => {
            try {
                const user = await Auth.currentAuthenticatedUser();
                console.debug('LOGIN APP. AUTH CONTEXT. GOT USER', user);
                setUser(user);

                try {
                    const {
                        data: profile,
                        status,
                        statusText,
                    } = await fetch(user.username);

                    if (status !== 200) {
                        throw new Error(statusText);
                    }
                    console.debug(
                        'LOGIN APP. AUTH CONTEXT. GOT PROFILE',
                        profile
                    );
                    setProfile(profile);
                } catch (error) {
                    console.trace(
                        'LOGIN APP. AUTH CONTEXT. FETCH PROFILE ERROR',
                        error
                    );
                }

                try {
                    const session = await Auth.userSession(user);
                    console.debug(
                        'LOGIN APP. AUTH CONTEXT. GOT SESSION',
                        session
                    );
                    setSession(session);
                } catch (error) {
                    console.trace(
                        'LOGIN APP. AUTH CONTEXT. SESSION EXCEPTION: ',
                        error
                    );
                }
            } catch (error) {
                console.trace(
                    'LOGIN APP. AUTH CONTEXT. CURRENT USER EXCEPTION',
                    error
                );
            }
        };

        console.trace(
            'LOGIN APP. AUTH CONTEXT. RUN CONFIGURE FOR ACCOUNT',
            account.emailAddress
        );
        Amplify.configure({
                              Auth: {
                                  userPoolId: account.cognitoUserPoolId,
                                  userPoolWebClientId: account.appClientId,
                              },
                          });

        run();
    }, [account]);

    return {user, profile, session};
};
